/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchWorkers = async () => {
    const workers = await apiInputService.get("/Worker")
    const { data } = workers;

    return data;
}


export const useWorkersQuery = (subscription: string, options?: any) => {
    return useQuery<any[]>(["workers", subscription], () => fetchWorkers(), {
        
        refetchOnMount: false,
        staleTime: Infinity,
        ...options
    });
}